import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { DataGrid } from "@material-ui/data-grid"
import { DeleteOutline } from "@material-ui/icons"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
// Data
import { deleteProduct, createProduct, getProducts } from "../../redux/apiCalls"
// Styles
import {
   Container,
   GridWrapper,
   Main,
   Wrapper,
   ProductColumn,
   ProductImage,
   StyledLink,
   StyledButton,
   StyledIcon,
   Action,
   TitleWrapper,
   Title,
   TitleButton,
   Message,
} from "./ProductList.styles"

const ProductList = () => {
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const products = useSelector((state) => state.product.products)
   const [errorMessage, setErrorMessage] = useState("")

   const eansArray = products.map((product) =>
      product.variations.map((variation) => variation.ean)
   )
   let eans = []
   for (let i = 0; i < eansArray.length; i++) {
      eans = [...eans, ...eansArray[i]]
   }
   const nextEan = Math.max(...eans) + 1

   useEffect(() => {
      getProducts(dispatch)
   }, [dispatch])

   const handleDelete = (id) => {
      deleteProduct(id, dispatch)
   }

   const handleClone = async (id) => {
      const product = products.find((item) => item._id === id)
      const newProduct = {
         categories: product.categories,
         collectionSeason: product.collectionSeason,
         desc: product.desc,
         gender: product.gender,
         latest: product.latest,
         lensHeight: product.lensHeight,
         lensWidth: product.lensWidth,
         material: product.material,
         nose: product.nose,
         outOfCollection: product.outOfCollection,
         prices: product.prices,
         ranking: product.ranking,
         shape: product.shape,
         size: product.size,
         templeLength: product.templeLength,
         title: "Cloned product",
         totalWidth: product.totalWidth,
         variations: [
            {
               code: "001",
               collectionSeason: product.variations[0].collectionSeason,
               detailedColor: product.variations[0].detailedColor,
               ean: nextEan,
               imagesDark: [],
               imagesLight: [],
               inventory: 75,
               mainColor: product.variations[0].mainColor,
               outOfCollection: product.variations[0].outOfCollection,
               secondColor: product.variations[0].secondColor,
            },
            {
               code: "002",
               collectionSeason: product.variations[1].collectionSeason,
               detailedColor: product.variations[1].detailedColor,
               ean: nextEan + 1,
               imagesDark: [],
               imagesLight: [],
               inventory: 75,
               mainColor: product.variations[1].mainColor,
               outOfCollection: product.variations[1].outOfCollection,
               secondColor: product.variations[1].secondColor,
            },
            {
               code: "003",
               collectionSeason: product.variations[2].collectionSeason,
               detailedColor: product.variations[2].detailedColor,
               ean: nextEan + 2,
               imagesDark: [],
               imagesLight: [],
               inventory: 75,
               mainColor: product.variations[2].mainColor,
               outOfCollection: product.variations[2].outOfCollection,
               secondColor: product.variations[2].secondColor,
            },
            {
               code: "004",
               collectionSeason: product.variations[3].collectionSeason,
               detailedColor: product.variations[3].detailedColor,
               ean: nextEan + 3,
               imagesDark: [],
               imagesLight: [],
               inventory: 75,
               mainColor: product.variations[3].mainColor,
               outOfCollection: product.variations[3].outOfCollection,
               secondColor: product.variations[3].secondColor,
            },
         ],
      }

      const res = await createProduct(newProduct, dispatch)
      if (res === "success") {
         navigate("/products")
      } else {
         setErrorMessage(res.message)
      }
   }

   const columns = [
      { field: "_id", headerName: "ID", width: 210 },
      {
         field: "title",
         headerName: "Model",
         valueGetter: (params) => params.row.title,
         width: 160,
         renderCell: (params) => {
            return (
               <ProductColumn>
                  <ProductImage
                     src={params.row.variations[0].imagesLight[0]}
                     alt=""
                  />
                  {params.row.title}
               </ProductColumn>
            )
         },
      },
      { field: "categories", headerName: "Category", width: 140 },
      {
         field: "collectionSeason",
         headerName: "Season",
         width: 160,
      },
      {
         field: "gender",
         headerName: "Gender",
         width: 130,
      },
      {
         field: "shape",
         headerName: "Shape",
         width: 130,
      },
      {
         field: "material",
         headerName: "Material",
         width: 130,
      },
      {
         field: "size",
         headerName: "Size",
         width: 130,
      },
      {
         field: "totalWidth",
         headerName: "Width",
         width: 130,
      },
      {
         field: "action",
         headerName: "Action",
         width: 180,
         renderCell: (params) => {
            return (
               <Action>
                  <StyledLink to={"/product/" + params.row._id}>
                     <StyledButton>Edit</StyledButton>
                  </StyledLink>
                  <StyledButton onClick={() => handleClone(params.row._id)}>
                     Clone
                  </StyledButton>
                  <StyledIcon>
                     <DeleteOutline
                        onClick={() => handleDelete(params.row._id)}
                        color="secondary"
                     />
                  </StyledIcon>
               </Action>
            )
         },
      },
   ]

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Products List</Title>
                  <Link to="/newProduct">
                     <TitleButton>Create</TitleButton>
                  </Link>
               </TitleWrapper>
               <GridWrapper>
                  <DataGrid
                     rows={products}
                     columns={columns}
                     sortModel={[{ field: "title", sort: "asc" }]}
                     initialState={{
                        sorting: {
                           sortModel: [{ field: "title", sort: "asc" }],
                        },
                     }}
                     getRowId={(row) => row._id}
                     disableSelectionOnClick
                     pageSize={50}
                     checkboxSelection
                     autoHeight
                  />
               </GridWrapper>
               <Message>{errorMessage}</Message>
            </Main>
         </Container>
      </>
   )
}

export default ProductList
